export enum WeaponVisual {
	SMALL_GUN = "SMALL_GUN",
	CANNON = "CANNON",
	LAUNCHER = "LAUNCHER",
	DEPLOYER = "DEPLOYER",
	HEAT_LAUNCHER = "HEAT_LAUNCHER",
	GRENADE = "GRENADE",
	CLEAVER = "CLEAVER",
	NONE = "NONE",
}
